'use client'

import { useKeyboardEvent } from '@react-hookz/web'

import type { DependencyList } from 'react'

const platform =
  typeof window !== 'undefined'
    ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore - This is a new API that is not yet supported in all browsers.
      window.navigator?.userAgentData?.platform || window.navigator?.platform
    : ''
const isMac = platform.toUpperCase().includes('MAC')

export function useOnPageKeyDown(
  callback: (event: KeyboardEvent) => void,
  keys: Array<string> = ['Enter'],
  {
    alt = false,
    bodyOnly = true,
    ctrl = false,
    meta = false,
    shift = false,
    useMetaOnMac = true,
  } = {},
  deps: DependencyList = [],
) {
  useKeyboardEvent(
    (event: KeyboardEvent) => {
      if (
        (alt && !event.altKey) ||
        (ctrl && !(useMetaOnMac && isMac ? event.metaKey : event.ctrlKey)) ||
        (meta && !event.metaKey) ||
        (shift && !event.shiftKey)
      ) {
        return false
      }

      return (
        (bodyOnly === false || event.target === document.body) &&
        (keys.includes(event.key) || keys.includes(event.key?.toLowerCase()))
      )
    },
    callback,
    deps,
  )
}
